import React, { Component } from "react";
import { Link } from "react-router";
import CollapseImage from "../containers/assets/icon_collapse.svg";
import Map from "../components/ceo/analysis/market/map";
import UsInfo from "../components/ceo/analysis/market/us-info";
import EuropeInfo from "../components/ceo/analysis/market/europe-info";
import AsiaInfo from "../components/ceo/analysis/market/asia-info";
import HelpIconButtonWithTooltipAndTypeformModal from "../components/typeform/HelpIconButtonWithTooltipAndTypeformModal";
import TypeformContent from "../components/typeform/TypeformContent";
import { fetchAllStaticData } from "../api/StaticDataService";
import { logError } from "../services/utils";

class MarketAnalysis extends Component {
  constructor(props) {
    super(props);

    this.state = {
      units_demanded_automobile: 0,
      growth_rate_automobile: 0,
      units_demanded_mobile_phone: 0,
      growth_rate_mobile_phones: 0,
      roundInUrl: props.roundInUrl,
      currentRound: props.currentRound,
      rounds: props.rounds,
      customer_preferences: [],
      customer_demands: []
    };
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.state.roundInUrl !== nextProps.roundInUrl ||
      this.state.currentRound !== nextProps.currentRound ||
      (this.state.rounds.length === 0 && nextProps.rounds.length !== 0)
    ) {
      this.setState(
        {
          roundInUrl: nextProps.roundInUrl,
          currentRound: nextProps.currentRound,
          rounds: nextProps.rounds
        },
        () => {
          this.fetchData();
        }
      );
    }
  }

  componentDidMount() {
    this.fetchData();
  }

  get activeRound() {
    const { currentRound, roundInUrl } = this.state;

    if (roundInUrl !== null && roundInUrl !== currentRound) {
      return roundInUrl;
    }

    return currentRound;
  }

  fetchData = () => {
    const round_number = this.activeRound;

    // customer-analysis scope pre-filters all four tables to the
    // requested round and drops the round_number column, so
    // total_demand / demand_growth_rate arrive as single-row arrays
    // (take [0]) and customer_preferences / customer_demand arrive
    // fully filtered (no client-side filter needed).
    fetchAllStaticData(round_number, 'customer-analysis')
      .then(data => {
        let units_demanded_automobile = 0;
        let units_demanded_mobile_phone = 0;
        const obj1 = (data.totalDemand && data.totalDemand[0]) || null;
        if (obj1) {
          units_demanded_automobile = obj1.auto;
          units_demanded_mobile_phone = obj1.mobile;
        }

        let growth_rate_automobile = 0;
        let growth_rate_mobile_phones = 0;
        const obj2 = (data.demandGrowthRate && data.demandGrowthRate[0]) || null;
        if (obj2) {
          growth_rate_automobile = obj2.auto * 100;
          growth_rate_mobile_phones = obj2.mobile * 100;
        }

        const customer_preferences = data.customerPreferences || [];
        const customer_demands = data.customerDemand || [];

        this.setState({
          units_demanded_automobile,
          units_demanded_mobile_phone,
          growth_rate_automobile,
          growth_rate_mobile_phones,
          customer_preferences,
          customer_demands
        });
      })
      .catch(err => {
        logError(err, "MarketAnalysis", "fetchData");
      });
  };

  get url() {
    const { currentRound } = this.state;
    const activeRound = this.activeRound;
    const base_url = "/ceo/analysis";

    if (currentRound !== activeRound) {
      return `${base_url}?round=${activeRound}`;
    }

    return base_url;
  }

  render() {
    const {
      units_demanded_automobile,
      growth_rate_automobile,
      units_demanded_mobile_phone,
      growth_rate_mobile_phones,
      customer_preferences,
      customer_demands
    } = this.state;

    return (
      <section className="analysis section-mobile bg-gray">
        <div className="container-analysis none-shadow">
          <div className="row">
            <div className="col-xs-12">
              <h3 className="semibold">
                Customer Analysis
                <HelpIconButtonWithTooltipAndTypeformModal
                  {...TypeformContent.MARKET_ANALYSIS}
                />
                <Link to={this.url} className="icon-zoom">
                  <img
                    src={CollapseImage}
                    className="icon"
                    alt="CollapseImage"
                  />
                </Link>
              </h3>
            </div>
            <Map
              customer_preferences={customer_preferences}
              customer_demands={customer_demands}
            />
            <div className="col-md-6 col-xs-12">
              <div className="row">
                <UsInfo
                  units_demanded_automobile={units_demanded_automobile}
                  growth_rate_automobile={growth_rate_automobile}
                  units_demanded_mobile_phone={units_demanded_mobile_phone}
                  growth_rate_mobile_phones={growth_rate_mobile_phones}
                />
                <EuropeInfo />
                <AsiaInfo />
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default MarketAnalysis;



// WEBPACK FOOTER //
// ./src/containers/market-analysis.js